import { studentPersonaQueryOptions } from '@features/personas/queries';
import { StudentPersona } from '@features/personas/components/StudentPersona';
import { StudentPage } from '@features/student-page/components/StudentPage';
import { myWatchlistQueryOptions } from '@features/watchlist/queries';
import { requireRouteAudience } from '@services/router/routeAccess';
import { usePortalModeStore } from '@stores/usePortalModeStore';
import { createFileRoute } from '@tanstack/react-router'
import { studentYearPeriodAttendanceQueryOptions } from '@features/student-page/sub-features/student-year-period-attendance/queries';
import { studentMonthAttendanceQueryOptions } from '@features/student-page/sub-features/student-month-attendance/queries';

export const Route = createFileRoute('/_layout/students/$studentNo')({
    component: RouteComponent,
    loader: ({ params, context }) => {
        const { viewMode } = usePortalModeStore.getState()

        void Promise.all([
            context.queryClient.ensureQueryData(studentPersonaQueryOptions(params.studentNo)),
            context.queryClient.ensureQueryData(studentYearPeriodAttendanceQueryOptions(params.studentNo)),
            context.queryClient.ensureQueryData(studentMonthAttendanceQueryOptions(params.studentNo)),
            ...(viewMode === 'staff'
                ? [
                    context.queryClient.ensureQueryData(myWatchlistQueryOptions()),
                ]
                : []),
        ])
    },
    beforeLoad: requireRouteAudience(['staff', 'parent', 'student']),
    staticData: {
        crumb: {
            render: (match) => (
                <StudentPersona 
                    id={match.params.studentNo} 
                    avatarProps={{ size: 20 }}
                    textProps={{ size: 'sm', fw: 500 }}
                    showPhoto={false}
                    studentNumberStyle='none'
                    clickable={false}
                    hoverable={false}
                />
            )
        }
    }
})

function RouteComponent() {

    const { studentNo } = Route.useParams()

    return (
        <StudentPage studentNo={studentNo} />
    )
}
